export const variables={
    API_URL:"https://treeofphilosophers.it/backend/",
}